import React, {Component} from "react";
import PetaDigitalComponent from "../components/PetaDigitalComponent";

export class PetaDigital extends Component{
    render(){
        return(
            <PetaDigitalComponent />
        )
    }
}

export default PetaDigital;